module.exports = __webpack_public_path__ + "img/logo--grf.a27b40f4.svg";